var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"flex-center loading-indicator-container"},[_c('div',{staticClass:"loading-spinner"}),_c('span',[_vm._v(" Загрузка... ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }